import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
  TextField
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { BackdropCircular } from 'components';
import { sendRequestInformationEmailAPI } from 'api/index';


const useStyles = makeStyles((theme) => {
  return {
    dialogContainer: {
      '& > .MuiDialog-container .MuiDialog-paper': {
        minWidth: '60%'
      }
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    }
  };
});

export const RequestInfoModal = ({isOpened, handleClose}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [requestContent, setRequestContent] = useState('');
  const { isSendingEmail } = useSelector((state: IReduxState) => state.home);

  const handleSendEmail = async () => {
    const success = await sendRequestInformationEmailAPI({dispatch, message: requestContent});

    if (success) {
      handleClose();
    }
  };

  return (
    <Dialog
      open={isOpened}
      className={classes.dialogContainer}
      maxWidth="lg"
      onClose={handleClose}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">
        <Typography variant="h3">Request Information</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          multiline
          minRows={4}
          className="w-full mb-5"
          name="details"
          variant="outlined"
          onChange={(e) => setRequestContent(e.target.value)}
        />
        <Button
          className="mb-4"
          color="primary"
          variant="contained"
          disabled={!requestContent}
          onClick={handleSendEmail}
        >
          Submit Request
        </Button>
      </DialogContent>
      <BackdropCircular loading={isSendingEmail} />
    </Dialog>
  );
};
